/**
 * Подключение к Yjs без CodeMirror — для graph/tree/spreadsheet workspace.
 */
/* eslint-disable react-hooks/refs */
import { useEffect, useRef, useState } from 'react';
import * as Y from 'yjs';
import { WebsocketProvider } from 'y-websocket';

export default function CollaborativeYdocHost({
  sessionId,
  onYdocReady,
  onStatusChange,
  children,
}) {
  const [ydoc, setYdoc] = useState(null);
  const [connected, setConnected] = useState(false);
  const [userCount, setUserCount] = useState(0);
  const onYdocReadyRef = useRef(onYdocReady);
  const onStatusChangeRef = useRef(onStatusChange);
  onYdocReadyRef.current = onYdocReady;
  onStatusChangeRef.current = onStatusChange;

  useEffect(() => {
    if (typeof onStatusChangeRef.current === 'function') {
      onStatusChangeRef.current({ connected, userCount });
    }
  }, [connected, userCount]);

  useEffect(() => {
    if (!sessionId) return undefined;

    const doc = new Y.Doc();
    const isSecure = window.location.protocol === 'https:';
    const wsScheme = isSecure ? 'wss' : 'ws';
    const serverUrl = `${wsScheme}://${window.location.host}/ws/collaborative`;
    const provider = new WebsocketProvider(serverUrl, sessionId, doc);

    provider.on('status', (event) => {
      setConnected(event.status === 'connected');
    });
    provider.awareness.on('change', () => {
      setUserCount(provider.awareness.getStates().size);
    });

    setYdoc(doc);
    if (onYdocReadyRef.current) onYdocReadyRef.current(doc);

    return () => {
      if (onYdocReadyRef.current) onYdocReadyRef.current(null);
      provider.destroy();
      doc.destroy();
      setYdoc(null);
      setConnected(false);
      setUserCount(0);
    };
  }, [sessionId]);

  if (!sessionId) {
    return (
      <div className="editor-connecting">
        <div className="spinner" />
        <p>Подключение…</p>
      </div>
    );
  }

  return typeof children === 'function' ? children({ ydoc, connected, userCount }) : children;
}
